import React, { useContext } from 'react';
import PhaseContext from '../../PhaseContext';
import UnreadCoachCommentsBadge from './UnreadCoachCommentsBadge';
import StyledChallengeCard from '../../Challenge/ChallengeCard/ChallengeCardWithSearchMatching/StyledChallengeCard';
import KanbanPhase from '@/lib/constants/KanbanPhase.enum';
import ContentWrapper from '../../Challenge/ChallengeCard/ContentWrapper';
import ChallengeName from '../../Challenge/ChallengeCard/ChallengeName';
import PlannedEndDatePreview from '../../Challenge/ChallengeCard/PlannedEndDatePreview';
import TaskUserAvatars from './TaskUserAvatars';
import TaskCardPerspectiveAndWorldIndicators from './TaskCardPerspectiveAndWorldIndicators';
import { type TaskSummary } from '@/lib/types';
import TaskThumbnail, { type TaskSummaryWithThumbnail } from './TaskThumbnail';
import PortfolioItemCardTags from '../../portfolio-item/PortfolioItemCardTags';

type TaskCardProps = {
  task: TaskSummary;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  dragging: boolean;
  ref?: React.Ref<HTMLButtonElement>;
};

const TaskCard = ({ task, onClick, dragging, ref }: TaskCardProps) => {
  const phase = useContext(PhaseContext);

  return (
    <UnreadCoachCommentsBadge task={task}>
      <StyledChallengeCard
        big={phase !== KanbanPhase.DONE}
        cardColor={task.color}
        onClick={onClick}
        dragging={dragging}
        ref={ref}
      >
        <ContentWrapper>
          {task.thumbnail !== null && (
            <TaskThumbnail task={task as TaskSummaryWithThumbnail} />
          )}
          <TaskCardPerspectiveAndWorldIndicators task={task} />
          <ChallengeName challenge={task} />
          {phase !== KanbanPhase.DONE && task.plannedEndDate && (
            <PlannedEndDatePreview
              date={task.plannedEndDate}
              challengeColor={task.color}
            />
          )}
          <PortfolioItemCardTags portfolioItem={task} />
          <TaskUserAvatars task={task} />
        </ContentWrapper>
      </StyledChallengeCard>
    </UnreadCoachCommentsBadge>
  );
};

export default TaskCard;
